<template>
  <div class="wait py-3 px-8 d-flex align-center">
    <img class="icon mr-6" src="~@/static/custom-img/wait.png" alt="">
    <div class="text">
      <div class="text-title mb-1">{{ $t('onboardingSpecial.wait.title') }}</div>
      <div>{{ $t('onboardingSpecial.wait.text') }} 👇</div>
    </div>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>
.wait {
  margin: auto;
  max-width: 464px;
  height: 116px;
  background: #FFFFFF;
  box-shadow: inset 0px -2px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.icon {
  width: 90px;
  height: 90px;
}

.text {
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: -0.175px;
  color: #44445E;
}

.text-title {
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-transform: uppercase;
}

@media #{map-get($display-breakpoints, 'xs-only')} {
  text {
    font-size: 10px;
    line-height: 10px;
  }

  .text-title {
    font-size: 13px;
    line-height: 16px;
  }
}

</style>
